import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';

// Load third-party scripts at runtime to guard against empty IDs
// (Vite's index.html doesn't support conditional logic like EJS did)
if (!DEVELOPMENT && APPCUES_ACCOUNT_ID) {
  window.AppcuesSettings = { enableURLDetection: true };
  const appcuesScript = document.createElement('script');
  appcuesScript.async = true;
  appcuesScript.src = `//fast.appcues.com/${APPCUES_ACCOUNT_ID}.js`;
  document.head.appendChild(appcuesScript);
}

if (EXP_HUBSPOT_TRACKING_CODE_ID) {
  // Must be set before the HubSpot loader script runs
  (window as any).hsConversationsSettings = { loadImmediately: false };
  const hsScript = document.createElement('script');
  hsScript.id = 'hs-script-loader';
  hsScript.async = true;
  hsScript.defer = true;
  hsScript.src = `//js.hs-scripts.com/${EXP_HUBSPOT_TRACKING_CODE_ID}.js`;
  hsScript.onload = () => {
    // eslint-disable-next-line no-underscore-dangle, no-multi-assign, @typescript-eslint/naming-convention
    const hsp = ((window as any)._hsp = (window as any)._hsp || []);
    hsp.push(['revokeCookieConsent']);
  };
  document.head.appendChild(hsScript);
}

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
